(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('bhsApp')
        .constant('VERSION', "1.12.17")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
